/* eslint-disable unicorn/filename-case */
// TODO: Remove the above line after the ESLint config is fixed.
'use client';

import Error from 'next/error';

// https://github.com/vercel/next.js/issues/58055#issuecomment-1919949666
const NotFound: React.FC = () => {
  return <Error statusCode={404} />;
};

export default NotFound;
